module.exports = __webpack_public_path__ + "img/sent-email-gray.be9ec663.svg";